import { CustomColDef } from '@app/shared/bssh-data-table/custom-colDef';

export interface IColumnState {
    isVisible: boolean;
}

export interface IColumnSetting {
    Id: string;
    label: string;
    showAlways?: boolean;
}

export interface IUserGridSettings {
    limit?: number;
}

/**
 * Finds the `CustomColDef` in `columnDefs` that corresponds to the given
 * `IColumnSetting`, matching on `colId` first and falling back to `field`.
 *
 * This is the single source of truth for how column-setting entries are
 * correlated with ag-grid column definitions throughout the application
 * (used by `TableSettingsService.setGridColumnsVisibilityDefaults`,
 * `BsshDataTableComponent.syncShowAlwaysOntoColumnDefs`, etc.).
 */
export function findColDefForSetting(
    columnSetting: IColumnSetting,
    columnDefs: CustomColDef[]
): CustomColDef | undefined {
    return columnDefs.find(
        col => col.colId === columnSetting.Id || col.field === columnSetting.Id
    );
}
